import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIqTextLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-a01f3b90-c0de-4f1f-a5dc-bbb16684f2dd",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 17.4",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        isolation: isolate;\n        opacity: .6;\n      }\n\n      .st0, .st1 {\n        fill: #5f3dc4;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M38.3,14.4c0,.1,0,.3.2.3l1.7.6.6,1.7c0,.1.2.2.3.2s.3,0,.3-.2l.6-1.7,1.7-.6c.1,0,.2-.2.2-.3s0-.3-.2-.3l-1.7-.6-.6-1.7c0-.1-.2-.2-.3-.2s-.3,0-.3.2l-.6,1.7-1.7.6c-.1,0-.2.2-.2.3ZM39.2,2.9c0,.1,0,.3.2.3l1.7.6.6,1.7c0,.1.2.2.3.2s.3,0,.3-.2l.6-1.7,1.7-.6c.1,0,.2-.2.2-.3s0-.3-.2-.3l-1.7-.6-.6-1.7c0-.1-.2-.2-.3-.2s-.3,0-.3.2l-.6,1.7-1.7.6c-.1,0-.2.2-.2.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M33.8,3.2c0-.2-.2-.3-.4-.3s-.4.1-.4.3l-1.6,3.4-3.4,1.6c-.2,0-.3.2-.3.4s.1.4.3.4l3.4,1.6,1.6,3.4c0,.2.2.3.4.3s.4-.1.4-.3l1.6-3.4,3.4-1.6c.2,0,.3-.2.3-.4s-.1-.4-.3-.4l-3.4-1.6-1.6-3.4h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M0,15.9V.3h4.2v15.6H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M6.8,8.1c0-1.3.2-2.4.7-3.4.4-1,1-1.9,1.8-2.6s1.6-1.2,2.6-1.6C12.7.2,13.8,0,14.8,0s2.1.2,3.1.6,1.8.9,2.5,1.6,1.3,1.6,1.8,2.6.6,2.1.6,3.4-.1,1.9-.4,2.7-.6,1.6-1.1,2.2l1.8,2-2.7,2.3-1.8-2c-.6.3-1.1.5-1.8.6-.6.1-1.3.2-1.9.2-1.1,0-2.1-.2-3.1-.6-1-.4-1.8-.9-2.6-1.6s-1.3-1.6-1.8-2.6-.7-2.1-.6-3.4ZM11.1,8.1c0,.7.1,1.3.3,1.9s.5,1,.9,1.3.8.6,1.2.8.9.2,1.4.2.6,0,.9,0l-1.8-2.1,2.8-2.3,1.7,1.9c0-.2.1-.5.2-.8,0-.3,0-.6,0-.9,0-.7-.1-1.3-.3-1.8s-.5-.9-.9-1.3c-.4-.3-.8-.6-1.2-.8-.4-.2-.9-.2-1.4-.2s-.9,0-1.4.2c-.4.2-.9.4-1.2.8-.4.3-.6.8-.9,1.3-.2.5-.3,1.1-.3,1.8h0Z"
		})
	]
});
export default SvgIqTextLogo;
